import { Product } from '@app-types/product';

export const PACKS_CATEGORY = 'forfaits-packs';

export function isPack(product: Pick<Product, 'categories'>) {
    return product.categories.includes(PACKS_CATEGORY);
}
